import { httpClient } from './http-client';

export const getFiles = async () => {
  try {
    const response = await httpClient.get('api/upload_files.php');
    return response.data;
  } catch (error) {
    console.error('Error fetching files:', error);
    throw error;
  }
};
